import { Locale } from "./copy";

export function WorkspaceTitle({ area, companyName, locale }: { area: "owner" | "company"; companyName?: string; locale: Locale }): React.JSX.Element {
  const es = locale === "es";
  const detail = companyName !== undefined;
  return <div className={`workspace-title${detail ? " workspace-title--company-detail" : ""}`}>
    {!detail && <p className="eyebrow">{area === "owner" ? "FIVE CROWN / OWNER" : "FIVE CROWN / COMPANY"}</p>}
    <h1>{companyName ?? (area === "owner" ? (es ? "Empresas clientes" : "Customer companies") : (es ? "Su empresa" : "Your company"))}</h1>
    {!detail && <p className="muted">{es ? "Una empresa contiene sus propias sesiones, personal y cartones." : "A company contains its own sessions, staff and cards."}</p>}
  </div>;
}
